import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  Button,
  Autocomplete,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  Divider,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers";
import { useNavigate } from "react-router-dom";
import { CountriesData, checkUserLoggedIn } from "../shared/commonfunctions";

import { Formik, Form } from "formik";
import * as Yup from "yup";
import "./YourProfile.css";
import {
  PermanentandCorrespondanceAddressOutsideIndiaAPICall,
  deleteDocumentAPICall,
  stageDetailsAPICall,
  startOverAPICall,
} from "../shared/APICalls";
import { IYourProfilePrefillData } from "../shared/dtos";
import routesData from "../shared/routes.json";
import FatcaStyles from "../pages/Styles/OverseasAddress.module.scss";

import StageLayout from "../Layouts/StageLayout";
import icon from "../Components/assets/Images/iconnew.svg";

import BackDrop from "../Components/BackDrop";

import StartOverBackDrop from "../Components/StartOverBackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import PhoneInput, {
  formatPhoneNumberIntl,
  getCountryCallingCode,
  isValidPhoneNumber,
} from "react-phone-number-input";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import TickCircle from "../Components/assets/Images/tick-circle.svg";
import calenderImage from "../Components/assets/Images/calendar.svg";
import FormatterCheckerNominee from "./NomineePage/FormatCheckerNominee";
import { UploadSizes } from "../shared/constants";
import dayjs, { Dayjs } from "dayjs";
import { Country, State, City } from "country-state-city";
import SnackBar from "../Components/SnackBars/SnackBar";
import FormatterCheckerBankProof from "./FormatCheckerBankProof";
import { confirmAlert } from "react-confirm-alert";
import keyboardicon from "../Components/assets/Images/profileicongrey.svg";
import backicon from "../Components/assets/Images/back.svg";
import SucessSnackBar from "../Components/SnackBars/SucesssnackBar";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";

function DateIcon(props) {
  return <img src={calenderImage} style={{ width: "25px" }} />;
}

const schema = Yup.object().shape({
  premanentAddressaddress1: Yup.string().required("Address1 is Required"),
  premanentAddressaddress2: Yup.string(),
  premanentAddressaddress3: Yup.string(),
  premanentAddresscity: Yup.string().required("City is Required"),
  premanentAddressstate: Yup.object().required("State is Required"),
  premanentAddresscountry: Yup.object().required("Country is Required"),
  premanentAddresspincode: Yup.string().required("Pincode is Required"),
  // premanentAddressidProofNumber: Yup.string().required(
  //   "Id Proof Number is Required"
  // ),
  // premanentAddressproofValidTill: Yup.string().required(
  //   "Proof Validity Date is Required"
  // ),
  correspondanceAddressaddress1: Yup.string().required("Address1 is Required"),
  correspondanceAddressaddress2: Yup.string(),
  correspondanceAddressaddress3: Yup.string(),
  correspondanceAddresscity: Yup.string().notRequired(),
  correspondanceAddressstate: Yup.object().required("State is Required"),
  correspondanceAddresscountry: Yup.object().required("Country is Required"),
  correspondanceAddresspincode: Yup.string().required("Pincode is Required"),
  // correspondanceAddressidProofNumber: Yup.string().required(
  //   "Id Proof Number is Required"
  // ),
  // correspondanceAddressproofValidTill: Yup.string().required(
  //   "Proof Validity Date is Required"
  // ),
});

export default function OverseasAddress() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stateList = State.getAllStates();
  const cityList = City.getAllCities();
  const maxDate = dayjs().subtract(18, "year");
  //Loaders
  const [loading, setloading] = useState(false);
  const [prefilloading, setprefilloading] = useState(false);

  const [startOverloading, setstartOverloading] = useState(false);
  const [accounttype, setaccounttype] = useState("");

  const [prefillData, setprefillData] = useState<any>({
    premanentAddress: {
      address1: "",
      address2: "",
      address3: "",
      city: "",
      state: null,
      country: null,
      pincode: "",
      // idProofNumber: "",
      // proofValidTill: null,
    },
    correspondanceAddress: {
      address1: "",
      address2: "",
      address3: "",
      city: "",
      state: null,
      country: null,
      pincode: "",
      // idProofNumber: "",
      // proofValidTill: null,
    },
  });
  const [sameasPermanentAddress, setSameasPermanentAddress] = useState(false);
  const formats = ["pdf", "png", "jpg", "jpeg"];
  const [nomineeDocRef, setNomineDocref] = useState<any>();
  const [permanentaddressUrl, setPermanentaddressUrl] = useState<any>();
  const [correspondanceaddressUrl, setCorrespondanceaddressUrl] =
    useState<any>();
  const [selectedCountry, setSelectedCountry] = useState<any>({
    code: "",
    name: "",
  });
  const [selectedCountryCorrespondance, setSelectedCountryCorrespondance] =
    useState<any>({
      code: "",
      name: "",
    });
  const [selectedState, setSelectedState] = useState<any>({
    countryCode: "",
    isoCode: "",
    latitude: "",
    longitude: "",
    name: "",
  });
  const [selectedStateCorrespondance, setSelectedStateCorrespondance] =
    useState<any>({
      countryCode: "",
      isoCode: "",
      latitude: "",
      longitude: "",
      name: "",
    });
  const [CityData, setCityData] = useState([]);
  const [permanentAddressChecked, setPermanentAddressChecked] = useState(false);
  const [correspondanceAddressChecked, setCorrespondanceAddressChecked] =
    useState(false);
  const [CityDataCorrespondance, setCityDataCorrespondance] = useState([]);
  const [StatesData, setStatesData] = useState<any>([]);
  const [StatesDataCorrespondance, setStatesDataCorrespondance] = useState<any>(
    []
  );
  const [errormessage, setErrorMessage] = useState("");
  const [permanentProofUploaded, setPermanentProofUploaded] = useState("");
  const [correspondanceProofUploaded, setCorrespondanceProofUploaded] =
    useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const handlePreview = (data: any) => {};

  const handlePermanentDocumentID = (data: any) => {
    if (data !== "") {
      setPermanentProofUploaded("Document uploaded successfully");
      setSuccessMessage("Document uploaded successfully");
      setTimeout(() => {
        setSuccessMessage("");
      }, 5000);
    } else {
      setPermanentProofUploaded("");
    }
  };
  const handleCorrespondanceDocumentID = (data: any) => {
    // setCorrespondanceProofUploaded(data);
    if (data !== "") {
      setCorrespondanceProofUploaded("Document uploaded successfully");
      setSuccessMessage("Document uploaded successfully");
      setTimeout(() => {
        setSuccessMessage("");
      }, 5000);
    } else {
      setCorrespondanceProofUploaded("");
    }
  };
  //   console.log("countryListState", State.getAllStates());
  //   console.log("countryList", countryList.getData());

  const handleNomineeDocumentID = (data: any) => {};

  const [backdrop, setBackDrop] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
    setprefilloading(true);
    let obj: any = {
      stage: "address_details",
    };
    // console.log("accountstypes", accountstypes);
    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        dispatch(setCompletedStages(responseData?.data?.completed_stages));
        dispatch(setCurrentStage(responseData?.data?.current_stage));
        setRejectMessage(response.data.data.ErrorMessage);

        setaccounttype(responseData.data.account_type);
        if (responseData.data?.data?.permanent_proof[1]?.url) {
          setPermanentaddressUrl(
            responseData.data?.data?.permanent_proof[1].url
          );
          console.log("gjh");
          setPermanentProofUploaded("Document uploaded successfully");
        }

        if (responseData.data?.data?.correspondence_proof[1]?.url) {
          setCorrespondanceaddressUrl(
            responseData.data?.data?.correspondence_proof[1].url
          );
          setCorrespondanceProofUploaded("Document uploaded successfully");
        }

        if (response.data.data?.data?.address_details?.permanent_address) {
          const filteredStatePermanentAddress = stateList.filter(
            (a: any) =>
              a.name ===
              response.data.data?.data?.address_details?.permanent_address
                .permanent_state
          );

          const filteredCountryPermanentAddress = CountriesData().filter(
            (a: any) =>
              a.name ===
              response.data.data?.data?.address_details?.permanent_address
                .permanent_country
          );

          const filteredStateCorresspondanceAddress = stateList.filter(
            (a: any) =>
              a.name ===
              response.data.data?.data?.address_details?.correspondence_address
                .correspondence_state
          );

          const filteredCountryCorrespondanceAddress = CountriesData().filter(
            (a: any) =>
              a.name ===
              response.data.data?.data?.address_details?.correspondence_address
                .correspondence_country
          );

          setSelectedCountry(
            filteredCountryPermanentAddress.length > 0
              ? filteredCountryPermanentAddress[0]
              : { code: "", name: "" }
          );

          setSelectedState(
            response.data.data?.data?.address_details?.permanent_address
              .permanent_state === "Others"
              ? {
                  countryCode: "others",
                  isoCode: "others",
                  latitude: "others",
                  longitude: "others",
                  name: "Others",
                }
              : filteredStatePermanentAddress.length > 0
              ? filteredStatePermanentAddress[0]
              : {
                  countryCode: "",
                  isoCode: "",
                  latitude: "",
                  longitude: "",
                  name: "",
                }
          );

          setSelectedCountryCorrespondance(
            filteredCountryCorrespondanceAddress.length > 0
              ? filteredCountryCorrespondanceAddress[0]
              : { code: "", name: "" }
          );
          setSelectedStateCorrespondance(
            response.data.data?.data?.address_details?.correspondence_address
              .correspondence_state === "Others"
              ? {
                  countryCode: "others",
                  isoCode: "others",
                  latitude: "others",
                  longitude: "others",
                  name: "Others",
                }
              : filteredStateCorresspondanceAddress.length > 0
              ? filteredStateCorresspondanceAddress[0]
              : {
                  countryCode: "",
                  isoCode: "",
                  latitude: "",
                  longitude: "",
                  name: "",
                }
          );

          if (response.data.data?.data?.address_details?.permanent_address)
            setprefillData({
              premanentAddress: {
                address1:
                  response.data.data?.data?.address_details?.permanent_address
                    .permanent_address1,
                address2:
                  response.data.data?.data?.address_details?.permanent_address
                    .permanent_address2,
                address3:
                  response.data.data?.data?.address_details?.permanent_address
                    .permanent_address3,
                city: response.data.data?.data?.address_details
                  ?.permanent_address.permanent_city,
                state:
                  response.data.data?.data?.address_details?.permanent_address
                    .permanent_state === "Others"
                    ? {
                        countryCode: "others",
                        isoCode: "others",
                        latitude: "others",
                        longitude: "others",
                        name: "Others",
                      }
                    : filteredStatePermanentAddress[0],
                country: filteredCountryPermanentAddress[0],
                pincode:
                  response.data.data?.data?.address_details?.permanent_address
                    .permanent_pincode,
                // idProofNumber: response.data.data?.StageDetails
                //   ?.PermanentAddress?.PermanentAddress[0]?.idProofNumber
                //   ? response.data.data?.StageDetails?.PermanentAddress
                //       ?.PermanentAddress[0]?.idProofNumber
                //   : "",
                // proofValidTill: response.data.data?.StageDetails
                //   ?.PermanentAddress?.PermanentAddress[0]?.proofValidTill
                //   ? dayjs(
                //       response.data.data?.StageDetails?.PermanentAddress
                //         ?.PermanentAddress[0]?.proofValidTill
                //     )
                //   : null,
              },
              correspondanceAddress: {
                address1:
                  response.data.data?.data?.address_details
                    ?.correspondence_address.correspondence_address1,
                address2:
                  response.data.data?.data?.address_details
                    ?.correspondence_address.correspondence_address2,
                address3:
                  response.data.data?.data?.address_details
                    ?.correspondence_address.correspondence_address3,
                city: response.data.data?.data?.address_details
                  ?.correspondence_address.correspondence_city,
                state:
                  response.data.data?.data?.address_details
                    ?.correspondence_address.correspondence_state === "Others"
                    ? {
                        countryCode: "others",
                        isoCode: "others",
                        latitude: "others",
                        longitude: "others",
                        name: "Others",
                      }
                    : filteredStateCorresspondanceAddress[0],
                country: filteredCountryCorrespondanceAddress[0],
                pincode:
                  response.data.data?.data?.address_details
                    ?.correspondence_address.correspondence_pincode,
                // idProofNumber: response.data.data?.StageDetails
                //   ?.CorresspondanceAddress?.CorresspondanceAddress[0]
                //   ?.idProofNumber
                //   ? response.data.data?.StageDetails?.CorresspondanceAddress
                //       ?.CorresspondanceAddress[0]?.idProofNumber
                //   : "",
                // proofValidTill: response.data.data?.StageDetails
                //   ?.CorresspondanceAddress?.CorresspondanceAddress[0]
                //   ?.proofValidTill
                //   ? dayjs(
                //       response.data.data?.StageDetails?.CorresspondanceAddress
                //         ?.CorresspondanceAddress[0]?.proofValidTill
                //     )
                //   : null,
              },
            });
        }
        setprefilloading(false);
      })
      .catch((error: any) => {
        setprefilloading(false);
      });
  }, []);

  useEffect(() => {
    const filteredStates: any = stateList.filter(
      (a: any) => a.countryCode === selectedCountry.code
    );

    setStatesData([
      ...filteredStates,
      {
        countryCode: "others",
        isoCode: "others",
        latitude: "others",
        longitude: "others",
        name: "Others",
      },
    ]);
  }, [selectedCountry]);

  useEffect(() => {
    const filteredStates: any = stateList.filter(
      (a: any) => a.countryCode === selectedCountryCorrespondance.code
    );

    setStatesDataCorrespondance([
      ...filteredStates,
      {
        countryCode: "others",
        isoCode: "others",
        latitude: "others",
        longitude: "others",
        name: "Others",
      },
    ]);
  }, [selectedCountryCorrespondance]);

  useEffect(() => {
    const filteredCities: any = cityList.filter(
      (a: any) =>
        a.stateCode === selectedState.isoCode &&
        a.countryCode === selectedState.countryCode
    );

    // console.log("filteredStates", filteredCities);
    setCityData(filteredCities);
  }, [selectedState]);
  useEffect(() => {
    const filteredCities: any = cityList.filter(
      (a: any) =>
        a.stateCode === selectedStateCorrespondance.isoCode &&
        a.countryCode === selectedStateCorrespondance.countryCode
    );

    // console.log("filteredStates", filteredCities);
    setCityDataCorrespondance(filteredCities);
  }, [selectedStateCorrespondance]);

  function SubmitAddress(data: any) {
    // console.log("data", data);
    let obj: any = {
      permanent_address: {
        permanent_address1: data.premanentAddressaddress1,
        permanent_address2: data.premanentAddressaddress2,
        permanent_address3: data.premanentAddressaddress3,
        permanent_city: data.premanentAddresscity,
        permanent_state: data.premanentAddressstate.name,
        permanent_country: data.premanentAddresscountry.name,
        permanent_pincode: data.premanentAddresspincode,
        // idProofNumber: data.premanentAddressidProofNumber,
        // proofValidTill: data.premanentAddressproofValidTill.$d,
      },

      correspondence_address: {
        correspondence_address1: sameasPermanentAddress
          ? data.premanentAddressaddress1
          : data.correspondanceAddressaddress1,
        correspondence_address2: sameasPermanentAddress
          ? data.premanentAddressaddress2
          : data.correspondanceAddressaddress2,
        correspondence_address3: sameasPermanentAddress
          ? data.premanentAddressaddress3
          : data.correspondanceAddressaddress3,
        correspondence_city: sameasPermanentAddress
          ? data.premanentAddresscity
          : data.correspondanceAddresscity,
        correspondence_state: sameasPermanentAddress
          ? data.premanentAddressstate.name
          : data.correspondanceAddressstate.name,
        correspondence_country: sameasPermanentAddress
          ? data.premanentAddresscountry.name
          : data.correspondanceAddresscountry.name,
        correspondence_pincode: sameasPermanentAddress
          ? data.premanentAddresspincode
          : data.correspondanceAddresspincode,
        // idProofNumber: sameasPermanentAddress
        //   ? data.premanentAddressidProofNumber
        //   : data.correspondanceAddressidProofNumber,
        // proofValidTill: sameasPermanentAddress
        //   ? data.premanentAddressproofValidTill.$d
        //   : data.correspondanceAddressproofValidTill.$d,
      },

      // is_permanent_same_as_correspondance: sameasPermanentAddress,
    };
    // console.log("obj", obj);
    setloading(true);
    PermanentandCorrespondanceAddressOutsideIndiaAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
        setloading(false);

        setErrorMessage(
          error.response?.data?.message
            ? error.response?.data?.message
            : "Error Updating data"
        );
        setTimeout(() => {
          setErrorMessage("");
        }, 5000);
      });
  }

  const initialValues: any = {
    premanentAddressaddress1: prefillData.premanentAddress.address1,
    premanentAddressaddress2: prefillData.premanentAddress.address2,
    premanentAddressaddress3: prefillData.premanentAddress.address3,
    premanentAddresscity: prefillData.premanentAddress.city,
    premanentAddressstate: prefillData.premanentAddress.state,
    premanentAddresscountry: prefillData.premanentAddress.country,
    premanentAddresspincode: prefillData.premanentAddress.pincode,
    // premanentAddressidProofNumber: prefillData.premanentAddress.idProofNumber,
    // premanentAddressproofValidTill: prefillData.premanentAddress.proofValidTill,

    correspondanceAddressaddress1: prefillData.correspondanceAddress.address1,
    correspondanceAddressaddress2: prefillData.correspondanceAddress.address2,
    correspondanceAddressaddress3: prefillData.correspondanceAddress.address3,
    correspondanceAddresscity: prefillData.correspondanceAddress.city,
    correspondanceAddressstate: prefillData.correspondanceAddress.state,
    correspondanceAddresscountry: prefillData.correspondanceAddress.country,
    correspondanceAddresspincode: prefillData.correspondanceAddress.pincode,
    // correspondanceAddressidProofNumber:
    //   prefillData.correspondanceAddress.idProofNumber,
    // correspondanceAddressproofValidTill:
    //   prefillData.correspondanceAddress.proofValidTill,
  };

  return (
    <div className={FatcaStyles.mainWrapper}>
      <div className={FatcaStyles.topsection}>
        <div
          className={FatcaStyles.back}
          onClick={() => {
            if (accounttype === "NRO NON-PIS") {
              navigate("/bankDetails");
            } else {
              navigate("/pisBank");
            }
          }}
        >
          <img src={backicon} />{" "}
          <span className={FatcaStyles.backText}>Back</span>
        </div>
      </div>
      <div className={FatcaStyles.step}>
        <img src={keyboardicon} /> Step 7 of 10
      </div>
      <>
        <SnackBar message={errormessage} />
        <ErrorSnackBar message={rejectMessage} />
        <SucessSnackBar message={successMessage} />
        {backdrop && <StartOverBackDrop />}
        <div className={FatcaStyles.wrapper}>
          <div className={FatcaStyles.leftContainer}>
            <div className={FatcaStyles.headerSection}>
              <p className={FatcaStyles.signup}>Address Details</p>
            </div>
            {!prefilloading ? (
              <Formik
                validationSchema={schema}
                initialValues={initialValues}
                onSubmit={(values: any) => {
                  // console.log("values", values);
                  SubmitAddress(values);
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => {
                  // console.log("values", values);
                  // console.log("errors", errors);
                  return (
                    <form
                      noValidate
                      onSubmit={handleSubmit}
                      onKeyDown={(event) => {
                        event.code === "Enter" && handleSubmit();

                        // event.code.includes("Enter") && handleSubmit()
                      }}
                    >
                      <div className={FatcaStyles.contentMainWrapper}>
                        <div className={FatcaStyles.tablemain}>
                          <div className={FatcaStyles.checkBoxDiv}>
                            <FormGroup sx={{ width: "max-content" }}>
                              <FormControlLabel
                                sx={{ alignItems: "flex-start" }}
                                control={
                                  <Checkbox
                                    name="fatcacondition1"
                                    sx={{ padding: "0px", display: "none" }}
                                    checked={permanentAddressChecked}
                                    icon={<PanoramaFishEyeIcon />}
                                    checkedIcon={
                                      <img src={TickCircle} width={"24px"} />
                                    }
                                  />
                                }
                                label={
                                  <span className={FatcaStyles.label}>
                                    <span>
                                      Permanent Address / Indian Address{" "}
                                    </span>

                                    {/* basis from my NCO securities trading
                                      account. */}
                                  </span>
                                }
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <Stack margin={"10px 0"}>
                          <div className={FatcaStyles.topContainer}>
                            <div className={FatcaStyles.subContainer}>
                              <TextField
                                autoComplete="off"
                                className={FatcaStyles.textfield}
                                id="outlined-basicAddress1"
                                label="Address 1"
                                variant="outlined"
                                name="premanentAddressaddress1"
                                value={
                                  values.premanentAddressaddress1 &&
                                  values.premanentAddressaddress1.toUpperCase()
                                }
                                error={
                                  touched.premanentAddressaddress1 &&
                                  Boolean(errors.premanentAddressaddress1)
                                }
                                helperText={
                                  touched.premanentAddressaddress1 &&
                                  errors.premanentAddressaddress1?.toString()
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{
                                  sx: {
                                    "&::label": {
                                      fill: "#111827",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                    },
                                    color: "var(--Black-Black-500, #6B7280)",
                                    fontSize: "14px",
                                  },
                                  maxLength: 150,
                                  inputMode: "text",
                                  autoComplete: "new-password",
                                }}
                                sx={{
                                  fieldset: {
                                    borderColor: "#E5E7EB",
                                    borderRadius: "100px",
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: "#6B7280",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    "&.MuiFormLabel-filled": {
                                      color: "#111827",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                    },
                                  },
                                }}
                              />
                            </div>

                            <div className={FatcaStyles.subRightContainer}>
                              <TextField
                                autoComplete="off"
                                className={FatcaStyles.textfield}
                                id="outlined-basicAddress"
                                label="Address 2"
                                variant="outlined"
                                name="premanentAddressaddress2"
                                value={
                                  values.premanentAddressaddress2 &&
                                  values.premanentAddressaddress2.toUpperCase()
                                }
                                error={
                                  touched.premanentAddressaddress2 &&
                                  Boolean(errors.premanentAddressaddress2)
                                }
                                helperText={
                                  touched.premanentAddressaddress2 &&
                                  errors.premanentAddressaddress2?.toString()
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{
                                  sx: {
                                    "&::label": {
                                      fill: "#111827",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                    },
                                    color: "var(--Black-Black-500, #6B7280)",
                                    fontSize: "14px",
                                  },
                                  maxLength: 150,
                                  inputMode: "text",
                                  autoComplete: "new-password",
                                }}
                                sx={{
                                  fieldset: {
                                    borderColor: "#E5E7EB",
                                    borderRadius: "100px",
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: "#6B7280",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    "&.MuiFormLabel-filled": {
                                      color: "#111827",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                    },
                                  },
                                }}
                              />
                            </div>
                          </div>
                        </Stack>
                        <Stack margin={"10px 0"}>
                          <div className={FatcaStyles.topContainer}>
                            <div className={FatcaStyles.subContainer}>
                              <TextField
                                autoComplete="off"
                                className={FatcaStyles.textfield}
                                id="outlined-basicAddress"
                                label="Address 3"
                                variant="outlined"
                                name="premanentAddressaddress3"
                                value={
                                  values.premanentAddressaddress3 &&
                                  values.premanentAddressaddress3.toUpperCase()
                                }
                                error={
                                  touched.premanentAddressaddress3 &&
                                  Boolean(errors.premanentAddressaddress3)
                                }
                                helperText={
                                  touched.premanentAddressaddress3 &&
                                  errors.premanentAddressaddress3?.toString()
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{
                                  sx: {
                                    "&::label": {
                                      fill: "#111827",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                    },
                                    color: "var(--Black-Black-500, #6B7280)",
                                    fontSize: "14px",
                                  },
                                  maxLength: 150,
                                  inputMode: "text",
                                  autoComplete: "new-password",
                                }}
                                sx={{
                                  fieldset: {
                                    borderColor: "#E5E7EB",
                                    borderRadius: "100px",
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: "#6B7280",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    "&.MuiFormLabel-filled": {
                                      color: "#111827",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                    },
                                  },
                                }}
                              />
                            </div>

                            <div className={FatcaStyles.subRightContainer}>
                              <Autocomplete
                                // size="small"
                                className={FatcaStyles.textfield}
                                options={CountriesData()
                                  ?.filter(
                                    (list: any) => list.name !== "Pakistan"
                                  )
                                  .map((a: any) => a)}
                                value={values.premanentAddresscountry}
                                getOptionLabel={(option) => option.name}
                                onChange={(event: any, newValue: any) => {
                                  setFieldValue(
                                    "premanentAddresscountry",
                                    newValue
                                  );
                                  setFieldValue("premanentAddressstate", null);
                                  setFieldValue("premanentAddresscity", "");
                                  setCityData([]);
                                  setSelectedCountry(newValue);
                                  setStatesData([]);
                                }}
                                id="disable-clearable"
                                disableClearable
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={"Select Country"}
                                    helperText={
                                      touched.premanentAddresscountry &&
                                      errors.premanentAddresscountry?.toString()
                                    }
                                    error={
                                      touched.premanentAddresscountry &&
                                      Boolean(errors.premanentAddresscountry)
                                    }
                                    inputProps={{
                                      ...params.inputProps,
                                      sx: {
                                        color:
                                          "var(--Black-Black-500, #6B7280)",
                                        fontSize: "14px",
                                      },
                                      maxLength: 150,
                                      inputMode: "text",
                                      autoComplete: "new-password",
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                        },
                                      },
                                    }}
                                  />
                                )}
                                // renderTags={() => null}
                              />
                            </div>
                          </div>
                        </Stack>
                        <Stack margin={"10px 0"}>
                          <div className={FatcaStyles.topContainer}>
                            <div className={FatcaStyles.subContainer}>
                              <Autocomplete
                                // size="small"
                                freeSolo
                                className={FatcaStyles.textfield}
                                options={StatesData.map((a: any) => a)}
                                getOptionLabel={(option) => option.name}
                                value={values.premanentAddressstate}
                                onChange={(event: any, newValue: any) => {
                                  setFieldValue(
                                    "premanentAddressstate",
                                    newValue
                                  );
                                  setSelectedState(newValue);
                                  setFieldValue("premanentAddresscity", "");
                                }}
                                id="disable-clearable"
                                disableClearable
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={"Select State"}
                                    helperText={
                                      touched.premanentAddressstate &&
                                      errors.premanentAddressstate?.toString()
                                    }
                                    error={
                                      touched.premanentAddressstate &&
                                      Boolean(errors.premanentAddressstate)
                                    }
                                    inputProps={{
                                      ...params.inputProps,
                                      sx: {
                                        color:
                                          "var(--Black-Black-500, #6B7280)",
                                        fontSize: "14px",
                                      },
                                      maxLength: 150,
                                      inputMode: "text",
                                      autoComplete: "new-password",
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                        },
                                      },
                                    }}
                                  />
                                )}
                                // renderTags={() => null}
                              />
                            </div>

                            <div className={FatcaStyles.subRightContainer}>
                              <Autocomplete
                                freeSolo
                                className={FatcaStyles.textfield}
                                options={CityData.map((a: any) => a.name)}
                                value={values.premanentAddresscity}
                                onInputChange={(event: any, newValue: any) => {
                                  setFieldValue(
                                    "premanentAddresscity",
                                    newValue
                                  );
                                }}
                                id="disable-clearable"
                                disableClearable
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={"Select City"}
                                    helperText={
                                      touched.premanentAddresscity &&
                                      errors.premanentAddresscity?.toString()
                                    }
                                    error={
                                      touched.premanentAddresscity &&
                                      Boolean(errors.premanentAddresscity)
                                    }
                                    inputProps={{
                                      ...params.inputProps,
                                      sx: {
                                        color:
                                          "var(--Black-Black-500, #6B7280)",
                                        fontSize: "14px",
                                      },
                                      maxLength: 150,
                                      inputMode: "text",
                                      autoComplete: "new-password",
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                        },
                                      },
                                    }}
                                  />
                                )}
                                // renderTags={() => null}
                              />
                            </div>
                          </div>
                        </Stack>
                        <Stack margin={"10px 0"}>
                          <div className={FatcaStyles.topContainer}>
                            <div className={FatcaStyles.subContainer}>
                              <TextField
                                autoComplete="off"
                                className={FatcaStyles.textfield}
                                id="outlined-basicZipCode"
                                label="ZipCode"
                                variant="outlined"
                                name="premanentAddresspincode"
                                value={
                                  values.premanentAddresspincode &&
                                  values.premanentAddresspincode.toUpperCase()
                                }
                                error={
                                  touched.premanentAddresspincode &&
                                  Boolean(errors.premanentAddresspincode)
                                }
                                helperText={
                                  touched.premanentAddresspincode &&
                                  errors.premanentAddresspincode?.toString()
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{
                                  sx: {
                                    "&::label": {
                                      fill: "#111827",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                    },
                                    color: "var(--Black-Black-500, #6B7280)",
                                    fontSize: "14px",
                                  },
                                  maxLength: 10,
                                  // inputMode: "numeric",
                                  // pattern: "[0-9]*",
                                  autoComplete: "new-password",
                                }}
                                sx={{
                                  fieldset: {
                                    borderColor: "#E5E7EB",
                                    borderRadius: "100px",
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: "#6B7280",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    "&.MuiFormLabel-filled": {
                                      color: "#111827",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                    },
                                  },
                                }}
                                // onKeyPress={(event) => {
                                //   const keyCode = event.keyCode || event.which;
                                //   const keyValue = String.fromCharCode(keyCode);
                                //   const isValidKey = /^\d+$/.test(keyValue);

                                //   if (!isValidKey) {
                                //     event.preventDefault();
                                //   }
                                // }}
                              />
                            </div>
                            <div className={FatcaStyles.uploadSignatureSection}>
                              <div>
                                <p className={FatcaStyles.subText}>
                                  {" "}
                                  Upload Permanent Address Proof{" "}
                                </p>
                              </div>
                              <div style={{ marginRight: "10px" }}>
                                <FormatterCheckerBankProof
                                  acceptedFormats={formats}
                                  previewImage={handlePreview}
                                  documentRef={"permanent_address"}
                                  documentID={handlePermanentDocumentID}
                                  displayOptions={""}
                                  stageDetailsData={permanentaddressUrl}
                                  name={"Address Proof"}
                                  purpose={"permanent_address"}
                                  pdfSize={UploadSizes["bankproof"].pdfSize}
                                  imageSize={UploadSizes["bankproof"].imageSize}
                                />
                              </div>
                            </div>

                            {/* <div className={FatcaStyles.subRightContainer}>
                              <TextField
                                className={FatcaStyles.textfield}
                                id="outlined-basic"
                                label="ID Proof Number"
                                variant="outlined"
                                name="premanentAddressidProofNumber"
                                value={
                                  values.premanentAddressidProofNumber &&
                                  values.premanentAddressidProofNumber.toUpperCase()
                                }
                                error={
                                  touched.premanentAddressidProofNumber &&
                                  Boolean(errors.premanentAddressidProofNumber)
                                }
                                helperText={
                                  touched.premanentAddressidProofNumber &&
                                  errors.premanentAddressidProofNumber?.toString()
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                inputProps={{
                                  sx: {
                                    "&::label": {
                                      fill: "#111827",
                                      fontWeight: 400,
                                      fontSize: "14px",
                                    },
                                    color: "var(--Black-Black-500, #6B7280)",
                                    fontSize: "14px",
                                  },
                                  maxLength: 150,
                                  inputMode: "text",
                                }}
                                sx={{
                                  fieldset: {
                                    borderColor: "#E5E7EB",
                                    borderRadius: "100px",
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    color: "#6B7280",
                                    fontWeight: 400,
                                    fontSize: "14px",
                                    "&.MuiFormLabel-filled": {
                                      color: "#111827",
                                      fontWeight: 400,
                                      fontSize: "15px",
                                    },
                                  },
                                }}
                              />
                            </div> */}
                          </div>
                        </Stack>
                        <Stack margin={"10px 0"}>
                          <div className={FatcaStyles.topContainer}>
                            {/* <div className={FatcaStyles.subContainer}>
                              <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                  components={{
                                    OpenPickerIcon: DateIcon,
                                  }}
                                  id="premanentAddressproofValidTill"
                                  label="Proof valid till date"
                                  name="premanentAddressproofValidTill"
                                  format="DD/MM/YYYY"
                                  views={["year", "month", "day"]}
                                  value={values.premanentAddressproofValidTill}
                                  className={FatcaStyles.textfield}
                                  onChange={(date) => {
                                    handleChange({
                                      target: {
                                        name: "premanentAddressproofValidTill",
                                        value: date,
                                      },
                                    });
                                  }}
                                  onBlur={handleBlur}
                                  error={
                                    touched.premanentAddressproofValidTill &&
                                    Boolean(
                                      errors.premanentAddressproofValidTill
                                    )
                                  }
                                  helperText={
                                    touched.premanentAddressproofValidTill &&
                                    errors.premanentAddressproofValidTill
                                  }
                                  renderInput={(params: any) => (
                                    <TextField {...params} />
                                  )}
                                  minDate={dayjs().add(1, "day")}
                                  // views={undefined}
                                  {...(DatePicker as any)}
                                  InputLabelProps={{
                                    sx: {
                                      color: "grey", // Default label color
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      "&.MuiFormLabel-filled": {
                                        color: "#111827", // Label color when a value is selected
                                      },
                                    },
                                  }}
                                  sx={{
                                    width: "100%",
                                    fieldset: {
                                      borderColor: "#E5E7EB",
                                      borderRadius: "100px",
                                    },
                                    "& .MuiInputLabel-root": {
                                      color: "#6B7280", // Default label color for date picker
                                      fontWeight: 400,
                                      fontSize: "14px",
                                      "&.Mui-focused": {
                                        color: "#111827",
                                      },
                                      "&.MuiFormLabel-filled": {
                                        color: "#111827",
                                        fontWeight: 400,
                                        fontSize: "15px",
                                      },
                                    },
                                    "& .MuiOutlinedInput-input": {
                                      color: "var(--Black-Black-500, #6B7280)",
                                      fontSize: "14px",
                                    },
                                  }}
                                />
                                <FormHelperText
                                  sx={{
                                    width: "100%",
                                    color: "red",
                                    marginLeft: "15px",
                                  }}
                                >
                                  {touched.premanentAddressproofValidTill &&
                                    errors.premanentAddressproofValidTill?.toString()}
                                </FormHelperText>
                              </LocalizationProvider>
                            </div> */}
                          </div>
                        </Stack>

                        <div
                          className={FatcaStyles.tablemain}
                          style={{ marginTop: "20px" }}
                        >
                          <div className={FatcaStyles.checkBoxDiv}>
                            <FormGroup sx={{ width: "max-content" }}>
                              <FormControlLabel
                                sx={{ alignItems: "flex-start" }}
                                control={
                                  <Checkbox
                                    name="fatcacondition2"
                                    sx={{ padding: "0px", display: "none" }}
                                    checked={correspondanceAddressChecked}
                                    icon={<PanoramaFishEyeIcon />}
                                    checkedIcon={
                                      <img src={TickCircle} width={"24px"} />
                                    }
                                  />
                                }
                                label={
                                  <span className={FatcaStyles.label}>
                                    <span>
                                      {" "}
                                      Correspondence / Overseas Address
                                    </span>

                                    {/* basis from my NCO securities trading
                                      account. */}
                                  </span>
                                }
                              />
                            </FormGroup>
                          </div>
                        </div>

                        {/* <div className={FatcaStyles.tablemain}>
                        <div className={FatcaStyles.checkBoxDiv}>
                          <FormGroup sx={{ width: "max-content" }}>
                            <FormControlLabel
                              sx={{ alignItems: "flex-start" }}
                              control={
                                <Checkbox
                                  name="fatcacondition2"
                                  sx={{ padding: "0px" }}
                                  checked={sameasPermanentAddress}
                                  icon={<PanoramaFishEyeIcon />}
                                  checkedIcon={
                                    <img src={TickCircle} width={"24px"} />
                                  }
                                  onChange={(event) => {
                                    const { checked } = event.target;
                                    setSameasPermanentAddress(checked);
                                    handleCheckBoxCheck(
                                      checked,
                                      values,
                                      setFieldValue
                                    );
                                  }}
                                />
                              }
                              label={
                                <span className={FatcaStyles.label}>
                                  <span> Same as Permanent Address</span>
                                </span>
                              }
                            />
                          </FormGroup>
                        </div>
                      </div> */}
                        {/* ...........................................Correspondance.................................................... */}

                        {!sameasPermanentAddress && (
                          <div>
                            <Stack margin={"10px 0"}>
                              <div className={FatcaStyles.topContainer}>
                                <div className={FatcaStyles.subContainer}>
                                  <TextField
                                    autoComplete="off"
                                    className={FatcaStyles.textfield}
                                    id="outlined-basicaddress1"
                                    label="Address 1"
                                    variant="outlined"
                                    name="correspondanceAddressaddress1"
                                    value={
                                      values.correspondanceAddressaddress1 &&
                                      values.correspondanceAddressaddress1.toUpperCase()
                                    }
                                    error={
                                      touched.correspondanceAddressaddress1 &&
                                      Boolean(
                                        errors.correspondanceAddressaddress1
                                      )
                                    }
                                    helperText={
                                      touched.correspondanceAddressaddress1 &&
                                      errors.correspondanceAddressaddress1?.toString()
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    inputProps={{
                                      sx: {
                                        "&::label": {
                                          fill: "#111827",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        },
                                        color:
                                          "var(--Black-Black-500, #6B7280)",
                                        fontSize: "14px",
                                      },
                                      maxLength: 150,
                                      inputMode: "text",
                                      autoComplete: "new-password",
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                        },
                                      },
                                    }}
                                  />
                                </div>

                                <div className={FatcaStyles.subRightContainer}>
                                  <TextField
                                    autoComplete="off"
                                    className={FatcaStyles.textfield}
                                    id="outlined-basicAddres2"
                                    label="Address 2"
                                    variant="outlined"
                                    name="correspondanceAddressaddress2"
                                    value={
                                      values.correspondanceAddressaddress2 &&
                                      values.correspondanceAddressaddress2.toUpperCase()
                                    }
                                    error={
                                      touched.correspondanceAddressaddress2 &&
                                      Boolean(
                                        errors.correspondanceAddressaddress2
                                      )
                                    }
                                    helperText={
                                      touched.correspondanceAddressaddress2 &&
                                      errors.correspondanceAddressaddress2?.toString()
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    inputProps={{
                                      sx: {
                                        "&::label": {
                                          fill: "#111827",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        },
                                        color:
                                          "var(--Black-Black-500, #6B7280)",
                                        fontSize: "14px",
                                      },
                                      maxLength: 150,
                                      inputMode: "text",
                                      autoComplete: "new-password",
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                        },
                                      },
                                    }}
                                  />
                                </div>
                              </div>
                            </Stack>
                            <Stack margin={"10px 0"}>
                              <div className={FatcaStyles.topContainer}>
                                <div className={FatcaStyles.subContainer}>
                                  <TextField
                                    autoComplete="off"
                                    className={FatcaStyles.textfield}
                                    id="outlined-basicAddress3"
                                    label="Address 3"
                                    variant="outlined"
                                    name="correspondanceAddressaddress3"
                                    value={
                                      values.correspondanceAddressaddress3 &&
                                      values.correspondanceAddressaddress3.toUpperCase()
                                    }
                                    error={
                                      touched.correspondanceAddressaddress3 &&
                                      Boolean(
                                        errors.correspondanceAddressaddress3
                                      )
                                    }
                                    helperText={
                                      touched.correspondanceAddressaddress3 &&
                                      errors.correspondanceAddressaddress3?.toString()
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    inputProps={{
                                      sx: {
                                        "&::label": {
                                          fill: "#111827",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        },
                                        color:
                                          "var(--Black-Black-500, #6B7280)",
                                        fontSize: "14px",
                                      },
                                      maxLength: 150,
                                      inputMode: "text",
                                      autoComplete: "new-password",
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                        },
                                      },
                                    }}
                                  />
                                </div>

                                <div className={FatcaStyles.subRightContainer}>
                                  <Autocomplete
                                    // size="small"
                                    className={FatcaStyles.textfield}
                                    options={CountriesData()
                                      ?.filter(
                                        (list: any) => list.name !== "Pakistan"
                                      )
                                      .map((a: any) => a)}
                                    value={values.correspondanceAddresscountry}
                                    getOptionLabel={(option) => option.name}
                                    onChange={(event: any, newValue: any) => {
                                      setFieldValue(
                                        "correspondanceAddresscountry",
                                        newValue
                                      );
                                      setFieldValue(
                                        "correspondanceAddressstate",
                                        null
                                      );
                                      setFieldValue(
                                        "correspondanceAddresscity",
                                        ""
                                      );
                                      setCityDataCorrespondance([]);
                                      setSelectedCountryCorrespondance(
                                        newValue
                                      );
                                      setStatesDataCorrespondance([]);
                                    }}
                                    id="disable-clearable"
                                    disableClearable
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label={"Select Country"}
                                        helperText={
                                          touched.correspondanceAddresscountry &&
                                          errors.correspondanceAddresscountry?.toString()
                                        }
                                        error={
                                          touched.correspondanceAddresscountry &&
                                          Boolean(
                                            errors.correspondanceAddresscountry
                                          )
                                        }
                                        inputProps={{
                                          ...params.inputProps,
                                          sx: {
                                            color:
                                              "var(--Black-Black-500, #6B7280)",
                                            fontSize: "14px",
                                          },
                                          maxLength: 150,
                                          inputMode: "text",
                                          autoComplete: "new-password",
                                        }}
                                        sx={{
                                          fieldset: {
                                            borderColor: "#E5E7EB",
                                            borderRadius: "100px",
                                          },
                                        }}
                                        InputLabelProps={{
                                          sx: {
                                            color: "#6B7280",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            "&.MuiFormLabel-filled": {
                                              color: "#111827",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                    // renderTags={() => null}
                                  />
                                </div>
                              </div>
                            </Stack>
                            <Stack margin={"10px 0"}>
                              <div className={FatcaStyles.topContainer}>
                                <div className={FatcaStyles.subContainer}>
                                  <Autocomplete
                                    // size="small"
                                    freeSolo
                                    className={FatcaStyles.textfield}
                                    options={StatesDataCorrespondance.map(
                                      (a: any) => a
                                    )}
                                    getOptionLabel={(option) => option.name}
                                    value={values.correspondanceAddressstate}
                                    onChange={(event: any, newValue: any) => {
                                      setFieldValue(
                                        "correspondanceAddressstate",
                                        newValue
                                      );
                                      setSelectedStateCorrespondance(newValue);
                                      setFieldValue(
                                        "correspondanceAddresscity",
                                        ""
                                      );
                                    }}
                                    id="disable-clearable"
                                    disableClearable
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label={"Select State"}
                                        helperText={
                                          touched.correspondanceAddressstate &&
                                          errors.correspondanceAddressstate?.toString()
                                        }
                                        error={
                                          touched.correspondanceAddressstate &&
                                          Boolean(
                                            errors.correspondanceAddressstate
                                          )
                                        }
                                        inputProps={{
                                          ...params.inputProps,
                                          sx: {
                                            color:
                                              "var(--Black-Black-500, #6B7280)",
                                            fontSize: "14px",
                                          },
                                          maxLength: 150,
                                          inputMode: "text",
                                          autoComplete: "new-password",
                                        }}
                                        sx={{
                                          fieldset: {
                                            borderColor: "#E5E7EB",
                                            borderRadius: "100px",
                                          },
                                        }}
                                        InputLabelProps={{
                                          sx: {
                                            color: "#6B7280",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            "&.MuiFormLabel-filled": {
                                              color: "#111827",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                    // renderTags={() => null}
                                  />
                                </div>

                                <div className={FatcaStyles.subRightContainer}>
                                  <Autocomplete
                                    // size="small"
                                    freeSolo
                                    className={FatcaStyles.textfield}
                                    options={CityDataCorrespondance.map(
                                      (a: any) => a.name
                                    )}
                                    value={values.correspondanceAddresscity}
                                    onInputChange={(
                                      event: any,
                                      newValue: any
                                    ) => {
                                      setFieldValue(
                                        "correspondanceAddresscity",
                                        newValue
                                      );
                                    }}
                                    id="disable-clearable"
                                    disableClearable
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label={"Select City"}
                                        helperText={
                                          touched.correspondanceAddresscity &&
                                          errors.correspondanceAddresscity?.toString()
                                        }
                                        error={
                                          touched.correspondanceAddresscity &&
                                          Boolean(
                                            errors.correspondanceAddresscity
                                          )
                                        }
                                        inputProps={{
                                          ...params.inputProps,
                                          sx: {
                                            color:
                                              "var(--Black-Black-500, #6B7280)",
                                            fontSize: "14px",
                                          },
                                          maxLength: 150,
                                          inputMode: "text",
                                          autoComplete: "new-password",
                                        }}
                                        sx={{
                                          fieldset: {
                                            borderColor: "#E5E7EB",
                                            borderRadius: "100px",
                                          },
                                        }}
                                        InputLabelProps={{
                                          sx: {
                                            color: "#6B7280",
                                            fontWeight: 400,
                                            fontSize: "14px",
                                            "&.MuiFormLabel-filled": {
                                              color: "#111827",
                                              fontWeight: 400,
                                              fontSize: "15px",
                                            },
                                          },
                                        }}
                                      />
                                    )}
                                    // renderTags={() => null}
                                  />
                                </div>
                              </div>
                            </Stack>
                            <Stack margin={"10px 0"}>
                              <div className={FatcaStyles.topContainer}>
                                <div className={FatcaStyles.subContainer}>
                                  <TextField
                                    autoComplete="off"
                                    className={FatcaStyles.textfield}
                                    id="outlined-basicZipCode"
                                    label="ZipCode"
                                    variant="outlined"
                                    name="correspondanceAddresspincode"
                                    value={
                                      values.correspondanceAddresspincode &&
                                      values.correspondanceAddresspincode.toUpperCase()
                                    }
                                    error={
                                      touched.correspondanceAddresspincode &&
                                      Boolean(
                                        errors.correspondanceAddresspincode
                                      )
                                    }
                                    helperText={
                                      touched.correspondanceAddresspincode &&
                                      errors.correspondanceAddresspincode?.toString()
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    inputProps={{
                                      sx: {
                                        "&::label": {
                                          fill: "#111827",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        },
                                        color:
                                          "var(--Black-Black-500, #6B7280)",
                                        fontSize: "14px",
                                      },
                                      maxLength: 10,
                                      // inputMode: "numeric",
                                      // pattern: "[0-9]*",
                                      autoComplete: "new-password",
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                        },
                                      },
                                    }}
                                    // onKeyPress={(event) => {
                                    //   const keyCode =
                                    //     event.keyCode || event.which;
                                    //   const keyValue =
                                    //     String.fromCharCode(keyCode);
                                    //   const isValidKey = /^\d+$/.test(keyValue);

                                    //   if (!isValidKey) {
                                    //     event.preventDefault();
                                    //   }
                                    // }}
                                  />
                                </div>
                                <div
                                  className={FatcaStyles.uploadSignatureSection}
                                >
                                  <div>
                                    <p className={FatcaStyles.subText}>
                                      {" "}
                                      Upload Correspondence Address Proof{" "}
                                    </p>
                                  </div>
                                  <div style={{ marginRight: "10px" }}>
                                    <FormatterCheckerBankProof
                                      acceptedFormats={formats}
                                      previewImage={handlePreview}
                                      documentRef={"correspondence_address"}
                                      documentID={
                                        handleCorrespondanceDocumentID
                                      }
                                      displayOptions={""}
                                      stageDetailsData={
                                        correspondanceaddressUrl
                                      }
                                      name={"Correspondence Address Proof"}
                                      purpose={"correspondence_address"}
                                      pdfSize={UploadSizes["bankproof"].pdfSize}
                                      imageSize={
                                        UploadSizes["bankproof"].imageSize
                                      }
                                    />
                                  </div>
                                </div>

                                {/* <div className={FatcaStyles.subRightContainer}>
                                  <TextField
                                    className={FatcaStyles.textfield}
                                    id="outlined-basic"
                                    label="ID Proof Number"
                                    variant="outlined"
                                    name="correspondanceAddressidProofNumber"
                                    value={
                                      values.correspondanceAddressidProofNumber &&
                                      values.correspondanceAddressidProofNumber.toUpperCase()
                                    }
                                    error={
                                      touched.correspondanceAddressidProofNumber &&
                                      Boolean(
                                        errors.correspondanceAddressidProofNumber
                                      )
                                    }
                                    helperText={
                                      touched.correspondanceAddressidProofNumber &&
                                      errors.correspondanceAddressidProofNumber?.toString()
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    inputProps={{
                                      sx: {
                                        "&::label": {
                                          fill: "#111827",
                                          fontWeight: 400,
                                          fontSize: "14px",
                                        },
                                        color:
                                          "var(--Black-Black-500, #6B7280)",
                                        fontSize: "14px",
                                      },
                                      maxLength: 150,
                                      inputMode: "text",
                                    }}
                                    sx={{
                                      fieldset: {
                                        borderColor: "#E5E7EB",
                                        borderRadius: "100px",
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        color: "#6B7280",
                                        fontWeight: 400,
                                        fontSize: "14px",
                                        "&.MuiFormLabel-filled": {
                                          color: "#111827",
                                          fontWeight: 400,
                                          fontSize: "15px",
                                        },
                                      },
                                    }}
                                  />
                                </div> */}
                              </div>
                            </Stack>
                            {/* <Stack margin={"10px 0"}>
                              <div className={FatcaStyles.topContainer}>
                                <div className={FatcaStyles.subContainer}>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      components={{
                                        OpenPickerIcon: DateIcon,
                                      }}
                                      id="correspondanceAddressproofValidTill"
                                      label="Proof valid till date"
                                      name="correspondanceAddressproofValidTill"
                                      format="DD/MM/YYYY"
                                      views={["year", "month", "day"]}
                                      value={
                                        values.correspondanceAddressproofValidTill
                                      }
                                      className={FatcaStyles.textfield}
                                      onChange={(date) => {
                                        handleChange({
                                          target: {
                                            name: "correspondanceAddressproofValidTill",
                                            value: date,
                                          },
                                        });
                                      }}
                                      onBlur={handleBlur}
                                      error={
                                        touched.correspondanceAddressproofValidTill &&
                                        Boolean(
                                          errors.correspondanceAddressproofValidTill
                                        )
                                      }
                                      helperText={
                                        touched.correspondanceAddressproofValidTill &&
                                        errors.correspondanceAddressproofValidTill
                                      }
                                      renderInput={(params: any) => (
                                        <TextField {...params} />
                                      )}
                                      minDate={dayjs().add(1, "day")}
                                      // views={undefined}
                                      {...(DatePicker as any)}
                                      InputLabelProps={{
                                        sx: {
                                          color: "grey", // Default label color
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          "&.MuiFormLabel-filled": {
                                            color: "#111827", // Label color when a value is selected
                                          },
                                        },
                                      }}
                                      sx={{
                                        width: "100%",
                                        fieldset: {
                                          borderColor: "#E5E7EB",
                                          borderRadius: "100px",
                                        },
                                        "& .MuiInputLabel-root": {
                                          color: "#6B7280", // Default label color for date picker
                                          fontWeight: 400,
                                          fontSize: "14px",
                                          "&.Mui-focused": {
                                            color: "#111827",
                                          },
                                          "&.MuiFormLabel-filled": {
                                            color: "#111827",
                                            fontWeight: 400,
                                            fontSize: "15px",
                                          },
                                        },
                                        "& .MuiOutlinedInput-input": {
                                          color:
                                            "var(--Black-Black-500, #6B7280)",
                                          fontSize: "14px",
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </div>
                                <div
                                  className={FatcaStyles.uploadSignatureSection}
                                >
                                  <div>
                                    <p className={FatcaStyles.subText}>
                                      {" "}
                                      Upload Correspondence Address Proof{" "}
                                    </p>
                                  </div>
                                  <div style={{ marginRight: "10px" }}>
                                    <FormatterCheckerBankProof
                                      acceptedFormats={formats}
                                      previewImage={handlePreview}
                                      documentRef={"correspondence_address"}
                                      documentID={
                                        handleCorrespondanceDocumentID
                                      }
                                      displayOptions={""}
                                      stageDetailsData={
                                        correspondanceaddressUrl
                                      }
                                      name={"Correspondence Address Proof"}
                                      purpose={"correspondence_address"}
                                      pdfSize={UploadSizes["bankproof"].pdfSize}
                                      imageSize={
                                        UploadSizes["bankproof"].imageSize
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                            </Stack> */}
                          </div>
                        )}
                        {/* .................................................................................................................. */}
                      </div>

                      <div className={FatcaStyles.buttonStack}>
                        {permanentProofUploaded ===
                          "Document uploaded successfully" &&
                        correspondanceProofUploaded ===
                          "Document uploaded successfully" ? (
                          <LoadingButton
                            loading={loading}
                            variant="contained"
                            type="submit"
                            id="yourProfileContinueButton"
                            onClick={() => {
                              handleSubmit();
                            }}
                            className={FatcaStyles.approveButton}
                            sx={{ height: "50px" }}
                          >
                            Continue
                          </LoadingButton>
                        ) : (
                          <LoadingButton
                            loading={loading}
                            variant="contained"
                            type="submit"
                            id="yourProfileContinueButton"
                            onClick={() => {
                              handleSubmit();
                            }}
                            className={FatcaStyles.approveButton}
                            disabled={true}
                            sx={{ height: "50px" }}
                          >
                            Continue
                          </LoadingButton>
                        )}

                        {/* <div className={FatcaStyles.startOverSection}>
                          <img src={icon} className={FatcaStyles.iconImage} />
                          <p className={FatcaStyles.paratext}>
                            {" "}
                            if the above mentioned info not yours
                            <span
                              className={FatcaStyles.startoverbutton}
                              onClick={handleStartOver}
                            >
                              Start Over
                            </span>
                          </p>
                        </div> */}
                      </div>
                    </form>
                  );
                }}
              </Formik>
            ) : (
              <div style={{ height: "80vh" }}>
                <BackDrop />
              </div>
            )}
          </div>
        </div>
      </>
    </div>
  );
}
